import React from "react";
import { Route, Router, Switch } from "wouter";
import UserHomePage from "../user/userScreens/homePage";

const ErrorScreen = React.lazy(() => import("../404"));

const UserRoutes = () => {
  return (
    <Router>
      <React.Suspense>
        <Switch>
          <Route path="/" component={UserHomePage} />
          <Route component={ErrorScreen} />
        </Switch>
      </React.Suspense>
    </Router>
  );
};

export default UserRoutes;
